package com.ilussobsa

import com.lightningkite.kiteui.navigation.*
import com.ilussobsa.views.TakeNewVehicleImagesScreen
import com.ilussobsa.views.AudioTestScreen
import com.ilussobsa.views.BuyingCenterScreen
import com.ilussobsa.views.TutorialScreen
import com.ilussobsa.views.UsersScreen
import com.ilussobsa.views.UserScreen
import com.ilussobsa.views.SimulationScreen
import com.ilussobsa.views.SellingCenterScreen
import com.ilussobsa.views.LiveAuctionScreenOld
import com.ilussobsa.views.AnimationTestingScreen
import com.ilussobsa.views.PurchasesScreen
import com.ilussobsa.views.UpcomingAuctionsScreen
import com.ilussobsa.views.EditVehicleScreen
import com.ilussobsa.views.TermsOfUseScreen
import com.ilussobsa.views.LogInScreen
import com.ilussobsa.views.LiveAuctionRunlistScreen
import com.ilussobsa.views.SettingsScreen
import com.ilussobsa.views.TutorialsScreen
import com.ilussobsa.views.ProposalScreen
import com.ilussobsa.views.DashboardScreen
import com.ilussobsa.views.SearchScreen
import com.ilussobsa.views.SearchFilterScreen
import com.ilussobsa.views.VehicleDetailScreen
import com.ilussobsa.views.NotificationsScreen
import com.ilussobsa.views.NotificationSettingsScreen
import com.ilussobsa.views.FinancingFormScreen
import com.ilussobsa.views.PrivacyPolicyScreen
import com.ilussobsa.views.AuctionsScreen
import com.ilussobsa.views.AuctionConfigureDialog
import com.ilussobsa.views.PastAuctionsScreen
import com.ilussobsa.liveauction.LiveAuctionScreen
import kotlinx.serialization.ExperimentalSerializationApi


@OptIn(ExperimentalSerializationApi::class)
val AutoRoutes = Routes(
    parsers = listOf(
        label@{ 
            if (it.segments.size != 3) return@label null
            if (it.segments[0] != "upload-vehicle") return@label null
            if (it.segments[2] != "images") return@label null
            TakeNewVehicleImagesScreen(
                vehicleId = UrlProperties.decodeFromString(it.segments[1]),
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "audio-test") return@label null
            AudioTestScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "buying-center") return@label null
            BuyingCenterScreen(
            ).apply {
                UrlProperties.decodeFromStringMap("selectedLot", it.parameters, this.selectedLot)
                UrlProperties.decodeFromStringMap("search", it.parameters, this.search)
                UrlProperties.decodeFromStringMap("tab", it.parameters, this.tab)
                UrlProperties.decodeFromStringMap("sort", it.parameters, this.sort)
            }
        },
        label@{ 
            if (it.segments.size != 2) return@label null
            if (it.segments[0] != "tutorial") return@label null
            TutorialScreen(
                id = UrlProperties.decodeFromString(it.segments[1]),
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "users") return@label null
            UsersScreen(
            ).apply {
                UrlProperties.decodeFromStringMap("search", it.parameters, this.search)
                UrlProperties.decodeFromStringMap("sort", it.parameters, this.sort)
                UrlProperties.decodeFromStringMap("selectedUser", it.parameters, this.selectedUser)
            }
        },
        label@{ 
            if (it.segments.size != 2) return@label null
            if (it.segments[0] != "users") return@label null
            UserScreen(
                selectedUser = UrlProperties.decodeFromString(it.segments[1]),
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "simulation") return@label null
            SimulationScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "selling-center") return@label null
            SellingCenterScreen(
            ).apply {
                UrlProperties.decodeFromStringMap("selectedLot", it.parameters, this.selectedLot)
                UrlProperties.decodeFromStringMap("search", it.parameters, this.search)
                UrlProperties.decodeFromStringMap("tab", it.parameters, this.tab)
                UrlProperties.decodeFromStringMap("sort", it.parameters, this.sort)
            }
        },
        label@{ 
            if (it.segments.size != 2) return@label null
            if (it.segments[0] != "live-auction-old") return@label null
            LiveAuctionScreenOld(
                id = UrlProperties.decodeFromString(it.segments[1]),
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "animation-test") return@label null
            AnimationTestingScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "purchases") return@label null
            PurchasesScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "upcomingAuctions") return@label null
            UpcomingAuctionsScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 2) return@label null
            if (it.segments[0] != "edit-vehicle") return@label null
            EditVehicleScreen(
                vehicleId = UrlProperties.decodeFromString(it.segments[1]),
            ).apply {
                UrlProperties.decodeFromStringMap("tab", it.parameters, this.tab)
                UrlProperties.decodeFromStringMap("flowMode", it.parameters, this.flowMode)
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "terms") return@label null
            TermsOfUseScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "login") return@label null
            LogInScreen(
            ).apply {
                UrlProperties.decodeFromStringMap("backend", it.parameters, this.backend)
                UrlProperties.decodeFromStringMap("proof", it.parameters, this.proof)
                UrlProperties.decodeFromStringMap("notice", it.parameters, this.notice)
            }
        },
        label@{ 
            if (it.segments.size != 3) return@label null
            if (it.segments[0] != "live-auction") return@label null
            if (it.segments[2] != "runlist") return@label null
            LiveAuctionRunlistScreen(
                id = UrlProperties.decodeFromString(it.segments[1]),
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "settings") return@label null
            SettingsScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "tutorials") return@label null
            TutorialsScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "proposal") return@label null
            ProposalScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 0) return@label null
            DashboardScreen(
            ).apply {
                UrlProperties.decodeFromStringMap("fromStripe", it.parameters, this.fromStripe)
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "search") return@label null
            SearchScreen(
            ).apply {
                UrlProperties.decodeFromStringMap("selectedLot", it.parameters, this.selectedLot)
                UrlProperties.decodeFromStringMap("search", it.parameters, this.search)
                UrlProperties.decodeFromStringMap("savedSearchId", it.parameters, this.savedSearchId)
                UrlProperties.decodeFromStringMap("sort", it.parameters, this.sort)
                UrlProperties.decodeFromStringMap("query2", it.parameters, this.query2)
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "search-filter") return@label null
            SearchFilterScreen(
            ).apply {
                UrlProperties.decodeFromStringMap("selectedLot", it.parameters, this.selectedLot)
                UrlProperties.decodeFromStringMap("search", it.parameters, this.search)
                UrlProperties.decodeFromStringMap("savedSearchId", it.parameters, this.savedSearchId)
                UrlProperties.decodeFromStringMap("sort", it.parameters, this.sort)
                UrlProperties.decodeFromStringMap("query2", it.parameters, this.query2)
            }
        },
        label@{ 
            if (it.segments.size != 2) return@label null
            if (it.segments[0] != "vehicle") return@label null
            VehicleDetailScreen(
                id = UrlProperties.decodeFromString(it.segments[1]),
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "notifications") return@label null
            NotificationsScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 2) return@label null
            if (it.segments[0] != "notifications") return@label null
            if (it.segments[1] != "settings") return@label null
            NotificationSettingsScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "financing-form") return@label null
            FinancingFormScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "privacy") return@label null
            PrivacyPolicyScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "auctions") return@label null
            AuctionsScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 2) return@label null
            if (it.segments[0] != "auction-configure") return@label null
            AuctionConfigureDialog(
                id = UrlProperties.decodeFromString(it.segments[1]),
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 1) return@label null
            if (it.segments[0] != "past-auctions") return@label null
            PastAuctionsScreen(
            ).apply {
            }
        },
        label@{ 
            if (it.segments.size != 2) return@label null
            if (it.segments[0] != "live-auction") return@label null
            LiveAuctionScreen(
                id = UrlProperties.decodeFromString(it.segments[1]),
            ).apply {
            }
        },
    ),
    renderers = mapOf(
        TakeNewVehicleImagesScreen::class to label@{
            if (it !is TakeNewVehicleImagesScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("upload-vehicle", UrlProperties.encodeToString(it.vehicleId), "images"),
                parameters = p
            ), listOf())
        },
        AudioTestScreen::class to label@{
            if (it !is AudioTestScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("audio-test"),
                parameters = p
            ), listOf())
        },
        BuyingCenterScreen::class to label@{
            if (it !is BuyingCenterScreen) return@label null
            val p = HashMap<String, String>()
            UrlProperties.encodeToStringMap(it.selectedLot.value, "selectedLot", p)
            UrlProperties.encodeToStringMap(it.search.value, "search", p)
            UrlProperties.encodeToStringMap(it.tab.value, "tab", p)
            UrlProperties.encodeToStringMap(it.sort.value, "sort", p)
            RouteRendered(UrlLikePath(
                segments = listOf("buying-center"),
                parameters = p
            ), listOf(it.selectedLot, it.search, it.tab, it.sort))
        },
        TutorialScreen::class to label@{
            if (it !is TutorialScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("tutorial", UrlProperties.encodeToString(it.id)),
                parameters = p
            ), listOf())
        },
        UsersScreen::class to label@{
            if (it !is UsersScreen) return@label null
            val p = HashMap<String, String>()
            UrlProperties.encodeToStringMap(it.search.value, "search", p)
            UrlProperties.encodeToStringMap(it.sort.value, "sort", p)
            UrlProperties.encodeToStringMap(it.selectedUser.value, "selectedUser", p)
            RouteRendered(UrlLikePath(
                segments = listOf("users"),
                parameters = p
            ), listOf(it.search, it.sort, it.selectedUser))
        },
        UserScreen::class to label@{
            if (it !is UserScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("users", UrlProperties.encodeToString(it.selectedUser)),
                parameters = p
            ), listOf())
        },
        SimulationScreen::class to label@{
            if (it !is SimulationScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("simulation"),
                parameters = p
            ), listOf())
        },
        SellingCenterScreen::class to label@{
            if (it !is SellingCenterScreen) return@label null
            val p = HashMap<String, String>()
            UrlProperties.encodeToStringMap(it.selectedLot.value, "selectedLot", p)
            UrlProperties.encodeToStringMap(it.search.value, "search", p)
            UrlProperties.encodeToStringMap(it.tab.value, "tab", p)
            UrlProperties.encodeToStringMap(it.sort.value, "sort", p)
            RouteRendered(UrlLikePath(
                segments = listOf("selling-center"),
                parameters = p
            ), listOf(it.selectedLot, it.search, it.tab, it.sort))
        },
        LiveAuctionScreenOld::class to label@{
            if (it !is LiveAuctionScreenOld) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("live-auction-old", UrlProperties.encodeToString(it.id)),
                parameters = p
            ), listOf())
        },
        AnimationTestingScreen::class to label@{
            if (it !is AnimationTestingScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("animation-test"),
                parameters = p
            ), listOf())
        },
        PurchasesScreen::class to label@{
            if (it !is PurchasesScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("purchases"),
                parameters = p
            ), listOf())
        },
        UpcomingAuctionsScreen::class to label@{
            if (it !is UpcomingAuctionsScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("upcomingAuctions"),
                parameters = p
            ), listOf())
        },
        EditVehicleScreen::class to label@{
            if (it !is EditVehicleScreen) return@label null
            val p = HashMap<String, String>()
            UrlProperties.encodeToStringMap(it.tab.value, "tab", p)
            UrlProperties.encodeToStringMap(it.flowMode.value, "flowMode", p)
            RouteRendered(UrlLikePath(
                segments = listOf("edit-vehicle", UrlProperties.encodeToString(it.vehicleId)),
                parameters = p
            ), listOf(it.tab, it.flowMode))
        },
        TermsOfUseScreen::class to label@{
            if (it !is TermsOfUseScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("terms"),
                parameters = p
            ), listOf())
        },
        LogInScreen::class to label@{
            if (it !is LogInScreen) return@label null
            val p = HashMap<String, String>()
            UrlProperties.encodeToStringMap(it.backend.value, "backend", p)
            UrlProperties.encodeToStringMap(it.proof.value, "proof", p)
            UrlProperties.encodeToStringMap(it.notice.value, "notice", p)
            RouteRendered(UrlLikePath(
                segments = listOf("login"),
                parameters = p
            ), listOf(it.backend, it.proof, it.notice))
        },
        LiveAuctionRunlistScreen::class to label@{
            if (it !is LiveAuctionRunlistScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("live-auction", UrlProperties.encodeToString(it.id), "runlist"),
                parameters = p
            ), listOf())
        },
        SettingsScreen::class to label@{
            if (it !is SettingsScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("settings"),
                parameters = p
            ), listOf())
        },
        TutorialsScreen::class to label@{
            if (it !is TutorialsScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("tutorials"),
                parameters = p
            ), listOf())
        },
        ProposalScreen::class to label@{
            if (it !is ProposalScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("proposal"),
                parameters = p
            ), listOf())
        },
        DashboardScreen::class to label@{
            if (it !is DashboardScreen) return@label null
            val p = HashMap<String, String>()
            UrlProperties.encodeToStringMap(it.fromStripe.value, "fromStripe", p)
            RouteRendered(UrlLikePath(
                segments = listOf(),
                parameters = p
            ), listOf(it.fromStripe))
        },
        SearchScreen::class to label@{
            if (it !is SearchScreen) return@label null
            val p = HashMap<String, String>()
            UrlProperties.encodeToStringMap(it.selectedLot.value, "selectedLot", p)
            UrlProperties.encodeToStringMap(it.search.value, "search", p)
            UrlProperties.encodeToStringMap(it.savedSearchId.value, "savedSearchId", p)
            UrlProperties.encodeToStringMap(it.sort.value, "sort", p)
            UrlProperties.encodeToStringMap(it.query2.value, "query2", p)
            RouteRendered(UrlLikePath(
                segments = listOf("search"),
                parameters = p
            ), listOf(it.selectedLot, it.search, it.savedSearchId, it.sort, it.query2))
        },
        SearchFilterScreen::class to label@{
            if (it !is SearchFilterScreen) return@label null
            val p = HashMap<String, String>()
            UrlProperties.encodeToStringMap(it.selectedLot.value, "selectedLot", p)
            UrlProperties.encodeToStringMap(it.search.value, "search", p)
            UrlProperties.encodeToStringMap(it.savedSearchId.value, "savedSearchId", p)
            UrlProperties.encodeToStringMap(it.sort.value, "sort", p)
            UrlProperties.encodeToStringMap(it.query2.value, "query2", p)
            RouteRendered(UrlLikePath(
                segments = listOf("search-filter"),
                parameters = p
            ), listOf(it.selectedLot, it.search, it.savedSearchId, it.sort, it.query2))
        },
        VehicleDetailScreen::class to label@{
            if (it !is VehicleDetailScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("vehicle", UrlProperties.encodeToString(it.id)),
                parameters = p
            ), listOf())
        },
        NotificationsScreen::class to label@{
            if (it !is NotificationsScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("notifications"),
                parameters = p
            ), listOf())
        },
        NotificationSettingsScreen::class to label@{
            if (it !is NotificationSettingsScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("notifications", "settings"),
                parameters = p
            ), listOf())
        },
        FinancingFormScreen::class to label@{
            if (it !is FinancingFormScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("financing-form"),
                parameters = p
            ), listOf())
        },
        PrivacyPolicyScreen::class to label@{
            if (it !is PrivacyPolicyScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("privacy"),
                parameters = p
            ), listOf())
        },
        AuctionsScreen::class to label@{
            if (it !is AuctionsScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("auctions"),
                parameters = p
            ), listOf())
        },
        AuctionConfigureDialog::class to label@{
            if (it !is AuctionConfigureDialog) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("auction-configure", UrlProperties.encodeToString(it.id)),
                parameters = p
            ), listOf())
        },
        PastAuctionsScreen::class to label@{
            if (it !is PastAuctionsScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("past-auctions"),
                parameters = p
            ), listOf())
        },
        LiveAuctionScreen::class to label@{
            if (it !is LiveAuctionScreen) return@label null
            val p = HashMap<String, String>()
            RouteRendered(UrlLikePath(
                segments = listOf("live-auction", UrlProperties.encodeToString(it.id)),
                parameters = p
            ), listOf())
        },
    ),
)
